import Logo from "./Logo";
import { Trans } from "react-i18next";
import React, { useMemo } from "react";
import { groupBy } from "lodash";
import { Table } from "reactstrap";

const TypeTable = ({ title, lines, total }) => {
  if(total >0)
    return (
      <div className="mb-3">
        <h4 className="mb-0">
          <Trans>{title}</Trans>
        </h4>
        <Table size="sm" >
          <thead>
            <tr className="table-secondary">
              <th className="border-top-0"><Trans>Name</Trans></th>
              <th className="text-end border-top-0">
                <Trans>Amount</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {lines.map((i) => (
              <tr key={i.id} >
                <td>{i.description}</td>
                <td className="text-end">{i.type === 'DEDUCTION' ? `(${i.amount})` : i.amount}</td>
              </tr>
            ))}
            <tr className="table-light">
              <td className="text-end font-weight-bold w-100">
                <Trans>Total</Trans>
              </td>
              <td className="text-end font-weight-bold">{total}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
    return null
};

export const PaySlipDetail = ({ item, settings, noLogo }) => {
  const grouped = useMemo(() => groupBy(item.lines, "type"), [item]);
  return (
    <div>
      {!noLogo && <Logo value={settings.logo} />}
      <h5 className="font-weight-bold">{item.employee__full_name}</h5>
      <div>
        <Trans>Pay Period:</Trans>{" "}
        <span className="font-weight-bold">
          {item.pay_run__start_date}:{item.pay_run__end_date}
        </span>
      </div>
      <hr />
      <TypeTable
        title="Gross"
        lines={grouped["EARNING"] || []}
        total={item.total_earnings}
      />
      <TypeTable
        title="Deductions"
        lines={grouped["DEDUCTION"] || []}
        total={item.total_deductions}
      />
      <TypeTable
        title="Allowances"
        lines={grouped["ALLOWANCE"] || []}
        total={item.total_allowances}
      />
      <TypeTable
        title="Reimbursements"
        lines={grouped["REIMBURSEMENT"] || []}
        total={item.total_reimbursements}
      />
      <TypeTable
        title="Tax"
        lines={grouped["TAX"] || []}
        total={item.total_tax}
      />
      <hr />
      <div className="d-flex justify-content-end">
        <h4 className="font-weight-bold">
          <span className="mr-4">
            <Trans>Net Pay:</Trans>
          </span>{" "}
          {item.net_pay}
        </h4>
      </div>
    </div>
  );
};

export default PaySlipDetail;
